import { PageBody } from '@library/components/layout/PageBody';
import { PageFooterSteps } from '@library/components/layout/PageFooterSteps';

export interface ResolutionDetailsStepProps {
  children: React.ReactNode;
  isDisabled: boolean;
  onClickContinue: () => void;
  onClickDiscard?: () => void;
  primaryButtonText?: string;
}

export const ResolutionDetailsStep = ({
  children,
  isDisabled,
  onClickContinue,
  onClickDiscard = undefined,
  primaryButtonText = 'Continue'
}: ResolutionDetailsStepProps) => {
  return (
    <div className="flex size-full flex-col">
      <PageBody className="flex grow flex-col items-center justify-center gap-6">
        {children}
      </PageBody>
      <PageFooterSteps
        isDisabled={isDisabled}
        onClickSecondary={onClickDiscard}
        onClickPrimary={onClickContinue}
        primaryButtonText={primaryButtonText}
        secondaryButtonText="Discard"
      />
    </div>
  );
};
